import { render, staticRenderFns } from "./OrdersTabLinks.vue?vue&type=template&id=7674ced9"
import script from "./OrdersTabLinks.vue?vue&type=script&lang=js"
export * from "./OrdersTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports